import React, { useMemo } from 'react';
import Select, { components, OptionProps } from 'react-select';
import { Box, Flex } from '@chakra-ui/react';
import classNames from 'classnames';
import { useReactSelectStyles } from '../hooks/useReactSelectStyles';

export interface OptionType {
  id: string;
  label: string;
  secondaryLabel?: string;
}

interface ChakraReactSelectProps {
  options: OptionType[];
  selectedId: string | undefined | null;
  onSelect: (id: string) => void;
}

const Option = (props: OptionProps<OptionType, false>) => {
  const { data, selectOption, isSelected } = props;

  return (
    <Flex
      onClick={() => {
        selectOption(data);
      }}
      direction="column"
      _hover={{
        bg: 'blue',
        cursor: 'pointer',
        color: 'white',
      }}
      sx={{
        '&.selected': {
          color: 'blue',
        },
      }}
      paddingX={4}
      paddingY={2}
      className={classNames({
        selected: isSelected,
      })}
    >
      <components.Option {...props} />
      {/* <span className="status">{statusMsg}</span> */}
    </Flex>
  );
};

const ChakraReactSelect = (props: ChakraReactSelectProps) => {
  const { options: opts, onSelect, selectedId } = props;
  const options = (() => {
    const groups = opts.reduce((groups, opt) => {
      const key = `${opt.secondaryLabel}`;
      if (!groups[key]) {
        groups[key] = [];
      }

      // @ts-ignore
      groups[key].push(opt);
      return groups;
    }, {} as Record<string, OptionType[]>);

    if (Object.entries(groups).length > 1) {
      return Object.values(groups).map((opts) => {
        return {
          label: opts[0]?.secondaryLabel,
          options: opts,
        };
      });
    } else {
      // @ts-ignore
      return groups[Object.keys(groups)[0]];
    }
  })();

  // TODO: USE chakra-form for this
  const themed = useReactSelectStyles();
  const styles = useMemo(
    () => ({
      ...themed,
      styles: {
        ...themed.styles,
        //@ts-ignore
        control: (base, props) => ({
          ...base,
          //@ts-ignore
          ...themed.styles?.control(base, props),
          height: 32,
          minHeight: 32,
        }),
        //@ts-ignore
        container: (base, props) => ({
          ...base,
          //@ts-ignore
          ...themed.styles?.container(base, props),
          width: '260px',
        }),
        //@ts-ignore
        input: (base) => ({ ...base, margin: 0 }),
        indicatorSeparator: () => ({ display: 'none' }),
        //@ts-ignore
        indicatorsContainer: (base) => ({ ...base, height: 32 }),
        option: () => ({}),
      },
    }),
    [themed],
  );

  let flatOpts = options;

  if (options.length > 0 && options[0].options !== undefined) {
    flatOpts = options.reduce((arr: any, curr: any) => {
      return [...arr, ...curr.options];
    }, []);
  }

  const selectedOption = flatOpts.find(
    (o: { id: string }) => o.id === selectedId,
  );

  return (
    <Box h="32px">
      {/* @ts-ignore */}
      <Select<OptionType, false>
        {...styles}
        components={{ Option }}
        options={options}
        getOptionLabel={(option) => option.label}
        getOptionValue={(option) => option.id}
        value={selectedOption}
        onChange={(opt) => {
          if (opt != null) {
            onSelect(opt.id);
          } else {
            // @ts-ignore
            onSelect(null);
          }
        }}
        isClearable
      />
    </Box>
  );
};

export default ChakraReactSelect;
